import React, { FC } from 'react';
import { Box } from '@mui/material';
import CalendarField from '../../../../../../../../components/CalendarField';
import { ADDITIONAL_FIELDS_META } from '../../model';
import { PeriodSectionProps } from '../../types/additionalFieldsForm';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';
import { parseIsoDateString } from '../../utils/parseIsoDateString';
import { AdditionalSelectField } from '../AdditionalSelectField';

type PeriodBillingSectionProps = PeriodSectionProps &
  Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    | 'handleDateChange'
    | 'handleDateClear'
    | 'handleSelectChange'
    | 'handleSelectClear'
  >;

export const PeriodBillingSection: FC<PeriodBillingSectionProps> = ({
  values,
  isFieldsDisabled,
  periodErrors,
  handleDateChange,
  handleDateClear,
  handleSelectChange,
  handleSelectClear,
}) => (
  <>
    <Box display="flex" gap={2} flexWrap="wrap">
      <CalendarField
        label={ADDITIONAL_FIELDS_META.periodStart.label}
        value={parseIsoDateString(values.periodStart)}
        disabled={isFieldsDisabled}
        onChange={handleDateChange('periodStart')}
        onClear={handleDateClear('periodStart')}
        error={periodErrors.periodStart}
        helperText={periodErrors.periodStart}
      />
      <CalendarField
        label={ADDITIONAL_FIELDS_META.periodEnd.label}
        value={parseIsoDateString(values.periodEnd)}
        disabled={isFieldsDisabled}
        onChange={handleDateChange('periodEnd')}
        onClear={handleDateClear('periodEnd')}
        error={periodErrors.periodEnd}
        helperText={periodErrors.periodEnd}
      />
    </Box>

    <Box display="flex" gap={2} flexWrap="wrap">
      <AdditionalSelectField
        label={ADDITIONAL_FIELDS_META.format.label}
        value={values.format}
        options={ADDITIONAL_FIELDS_META.format.enumValues ?? []}
        disabled={isFieldsDisabled}
        onChange={handleSelectChange('format')}
        onClear={handleSelectClear('format')}
      />
      <AdditionalSelectField
        label={ADDITIONAL_FIELDS_META.billing.label}
        value={values.billing}
        options={ADDITIONAL_FIELDS_META.billing.enumValues ?? []}
        disabled={isFieldsDisabled}
        onChange={handleSelectChange('billing')}
        onClear={handleSelectClear('billing')}
      />
      <AdditionalSelectField
        label={ADDITIONAL_FIELDS_META.trafficType.label}
        value={values.trafficType}
        options={ADDITIONAL_FIELDS_META.trafficType.enumValues ?? []}
        disabled={isFieldsDisabled}
        onChange={handleSelectChange('trafficType')}
        onClear={handleSelectClear('trafficType')}
      />
    </Box>
  </>
);
